import { apiClient } from "../config";

async function deleteForm(id: string) {
  const res = await apiClient.delete(`/admin/dynamic-forms/${id}`);
  return res.data;
}

export default deleteForm;
